import * as _ from 'lodash';

export interface IMangel {
   uid: string;                 // uid
   shortage_kind: string;       // Mangelart
   priority: string;            // Bewertung/Priorität
   date_applicable: string;     // festgestellt am/Prüftermin
   description: string;         // Mangeltext
   component: string;           // Komponente
   _key: string;                 // Database record key
}

export class Mangel implements IMangel {

   // new + clone
   static NEW_NULL_OBJECT = new Mangel(
      'UNKNOWN_OBJECT',       // uid
      '',                     // Mangelart
      '',                     // Bewertung/Priorität
      '',                     // festgestellt am/Prüftermin
      '',                     // Mangeltext
      '',                     // Komponente
      null                    // _key
   );
   static getNewObject(): Mangel {return _.cloneDeep(Mangel.NEW_NULL_OBJECT); }
   static getClone(group: Mangel): Mangel {return _.cloneDeep(group); }

   // json mapper
   static jsObjToClass({
      uid,
      shortage_kind,
      priority,
      date_applicable,
      description,
      component,
      _key
   }): Mangel {
      return new Mangel(
         uid,
         shortage_kind,
         priority,
         date_applicable,
         description,
         component,
         _key
      );
   }

   constructor(
      public uid: string,                 // uid
      public shortage_kind: string,       // Mangelart
      public priority: string,            // Bewertung/Priorität
      public date_applicable: string,     // festgestellt am/Prüftermin
      public description: string,         // Mangeltext
      public component: string,           // Komponente
      public _key: string                 // Database record key
   ) { }

   // public interface
   isVirgin() { return this.uid.length === 0; }

}



// WEBPACK FOOTER //
// /builds/cp/frap/t3/planer/src/app/maengel/model/mangel.ts